<!-- eslint-disable max-lines -->
<template>
    <div class="file-detail-subtab customer-ebca">
        <!-- <div class="file-detail-btn" v-if="isShowBtn">
            <lots-button type="text" icon="el-icon-circle-plus-outline" size="medium" v-has="authorityCode.subEcbaAdd"
                @click="handleUseStatus">新增</lots-button>
            <lots-button type="text" icon="el-icon-remove-outline" size="medium" :loading="saveLoading"
                v-has="authorityCode.subEcbaDel" @click="handleDelStatus">删除</lots-button>
        </div> -->
        <div class="file-detail-table">
            <table-box class="prescreen" v-loading="subTabTable.tableLoading" :selection="config.selection"
                :control="false" :columns="newColumns" :height="tableHeight" :tableData="subTabTable.totalData"
                :actions="config.actions" :editDisableRule="() => false" :allowRowClick="false"
                @action-click="actionClick" :rows="subTabTable.totalData" @selection-change="handleSelectedRow"
                @row-dblclick="(row) => rowDBclick(row)">
                <template v-slot:col-append="{ col, row }">
                    <div v-if="col.prop === 'billCode'">
                        <span size="mini" type="text" :title="row.billCode">{{ row.billCode || '' }}</span>
                    </div>
                    <div v-else-if="col.prop === 'routeCodes'">
                        <span>{{ getValByKey(row.routeCodes) || '' }}</span>
                    </div>
                </template>
            </table-box>
            <div class="footer">
                <lots-pagination @size-change="subTabTable.sizeChange" :current-page.sync="subTabTable.pageNo"
                    @current-change="subTabTable.pageChange" size="small"
                    layout="total, sizes, prev, pager, next, jumper" :total="subTabTable.pageTotal" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, watch, getCurrentInstance } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
// import lotsButton from '@/components/lots/lotsButton';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import {
    getCustomerIntroductionPage, deleteCustomerIntroduction
} from '@mdm/api/customer/customerIntroduction.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import { Message, MessageBox } from 'element-ui';
import { dictWithUrl } from '@/components/lots/api';
import _ from 'lodash';
export default {
    name: 'overseasList',
    components: {
        lotsPagination,
        tableBox
        // lotsButton
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 325
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.customerManage);
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        // const refs = setupContext.refs;
        const config = reactive(_.cloneDeep(tableConfig));
        const advanceDialogRef = ref(null);
        const isDisableBtn = ref(false);
        const saveLoading = ref(false);
        class OverseasListClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                return condition;
            };
            afterGetList(res) {
                if (res && res.list) {
                    subTabTable.pageTotal.value = res.totalCount;
                    subTabTable.totalData.value = res.list || [];
                }
            };
        }
        const subTabTable = new OverseasListClass({
            Api: {
                listApi: getCustomerIntroductionPage
            }
        });
        const newColumns = computed(() => {
            return config.columns;
        });
        const btnLoading = ref(false);
        const routeCodesList = ref({});
        const getDc = async () => {
            await dictWithUrl('SYS_ROUTE_TYPE').then(res => {
                if (res && +res.code === 0) {
                    const { SYS_ROUTE_TYPE = {} } = res.data;
                    const listStr = SYS_ROUTE_TYPE;
                    routeCodesList.value = listStr || {};
                }
            });
        };
        const getValByKey = (keys = []) => {
            const keyVals = [];
            if (keys?.length && routeCodesList.value) {
                for (let i = 0; i < keys.length; i++) {
                    keyVals.push(routeCodesList.value[keys[i]]);
                }
            }
            return keyVals.join(',');
        };
        const selections = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selections.value = selection;
        };
        const actionClick = (event, row, index) => {
            if (event === 'delete') {
                // 删除
                selections.value[0] = row;
                handleDelStatus();
            } else {
                // 审批/详情
                ctx.$router.push({
                    name: 'customerIntroductionChangeFlow',
                    query: {
                        // customerChangeType: type,
                        billCode: row.billCode,
                        customerCode: row.customerCode,
                        id: row.id,
                        type: event
                    }
                });
            }
        };
        const rowDBclick = (row) => {
            actionClick('update', row);
        };
        const handleUseStatus = () => {
            // 新增
            ctx.$router.push({
                name: 'customerIntroductionChangeFlow',
                query: {
                    type: 'add',
                    customerCode: props.detailData.customerCode
                }
            });
        };
        const handleDelStatus = () => {
            if (!selections.value.length) {
                return Message.warning('请选择一条数据进行操作');
            };
            if (selections.value.find(it => +it.approvalStatus !== 1)) {
                selections.value = [];
                return Message.warning('客户引入申请单已关联流程，禁止删除');
            }
            MessageBox.confirm(`确认删除当前选择的数据？`, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = selections.value.map(it => it.id);
                deleteCustomerIntroduction({ id: params.join(',') }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('删除成功');
                    }
                }).finally(() => {
                    selections.value = [];
                    props.detailData.customerCode && subTabTable.getList();
                });
            }).catch(() => { props.detailData.customerCode && subTabTable.getList(); });
        };
        watch(
            () => [props.activeName, props.detailData],
            // eslint-disable-next-line complexity
            async (newVal) => {
                if (newVal[0] === 'overseasIntroduction' && newVal[1].customerCode) {
                    await getDc();
                    props.detailData.customerCode && await subTabTable.getList();
                } else {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            subTabTable,
            advanceDialogRef,
            btnLoading,
            handleSelectedRow,
            isDisableBtn,
            saveLoading,
            authorityCode,
            newColumns,
            handleDelStatus,
            handleUseStatus,
            actionClick,
            rowDBclick,
            getValByKey,
            routeCodesList
        };
    }
};
</script>

<style lang="less" scoped>
.customer-ebca {
    .file-detail-btn {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
}

.el-table--border th.gutter:last-of-type {
    display: block !important;
    width: 17px !important;
}

.mip-page-link {
    color: #4285f5;
    cursor: pointer;

    &.no-wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
